export enum BalanceType {
    Cleared = "Cleared",
    Unbalanced = "Unbalanced",
    Livebalanced = "Livebalanced"
}
